import { StyledValidationMessage } from '@Components/Forms/ValidationMessage/styled';
import { HTMLAttributes } from 'react';

type Props = {
	children: React.ReactNode;
} & HTMLAttributes<HTMLDivElement>;

export default function ValidationMessage({ children, ...rest }: Props) {
	return (
		<StyledValidationMessage {...rest}>{children}</StyledValidationMessage>
	);
}
